import type { TextPropsTextConfig } from '@features/powerpoint';
import { themeV2 } from '@features/lci-report/domain/theme-v2';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants-v2';

type CalculationEntryV2Props = {
  label: string;
  definition: string | undefined;
};

export const calculationEntryV2 = (
  props: CalculationEntryV2Props
): TextPropsTextConfig[] => {
  return [
    {
      text: props.label,
      options: {
        breakLine: true,
        bold: true,
        color: themeV2.colors.inmarketGreen,
        fontFace: DEFAULT_FONT,
        paraSpaceBefore: 14,
      },
    },
    {
      text: props.definition,
      options: {
        breakLine: true,
        fontFace: DEFAULT_FONT,
      },
    },
  ];
};
